<template>
  <div>
    <div class="text-center">
      <span
        class="rounded-pill py-2 px-4 subtitle-1 white--text"
        :class="$t(`tokens.demands.status.${value.status}.color`)"
        v-text="$t(`tokens.demands.status.${value.status}.label`)"
      />
    </div>

    <div class="mx-10">
      <v-row align="center">
        <v-col cols="3" class="text-right">
          <span v-text="$t('tokens.demands.fields.createdBy')" />
        </v-col>
        <v-col cols="9">
          <v-text-field
            :value="`${value.createdBy.firstName} ${value.createdBy.lastName}`"
            class="mt-0 pt-0"
            readonly
            hide-details
          />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="3" class="text-right">
          <span v-text="$t('tokens.demands.fields.creationDate')" />
        </v-col>
        <v-col cols="9">
          <v-text-field
            :value="creationDate"
            class="mt-0 pt-0"
            readonly
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3" class="text-right">
          <span v-text="$t('tokens.demands.fields.tokenNumber')" />
        </v-col>
        <v-col cols="9">
          <v-text-field
            :value="value.tokenNumber.toLocaleString()"
            class="mt-0 pt-0"
            readonly
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3" class="text-right">
          <span v-text="$t('tokens.demands.fields.comment')" />
        </v-col>
        <v-col cols="9">
          <v-textarea
            :value="value.comment"
            class="mt-0 pt-0"
            readonly
            rows="8"
            hide-details
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Helpers from 'src/utils/helpers'

export default {
  name: 'CompanyDemandModalContainer',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    creationDate () {
      return this.value.creationDate
        ? Helpers.formatDate(this.value.creationDate, this.$t('date.dateAndTime'))
        : ''
    },
  },
}
</script>
